<template>
  <AppRouterLayout @changeLayout="changeLayout" v-if="showRouterFlag"></AppRouterLayout>
  <AppFrameLayout ref="frameLayout" v-else></AppFrameLayout>
</template>


<script lang="ts">
  export default {
    name:'appFrame'
  }
</script>
<script lang="ts" setup>
import {nextTick, ref, unref, watch} from 'vue';
import AppFrameLayout from './AppFrameLayout.vue';
import AppRouterLayout from './AppRouterLayout.vue';
import { useRouter } from 'vue-router'
import {useAppStore} from "@/store/modules/app";
import {usePageFlush} from "@/hooks/setting/usePageFlush";
import {PageEnum} from "@/enums/pageEnum";
import {StorageUtils} from 'xmgoing-utils';
import {useTabs} from "@/hooks/web/useTabs";

const router = useRouter();
const appStore = useAppStore();
const showRouterFlag=ref(appStore.showRouterFlag);
const frameLayout:any=ref(null);
const { closeAll } = useTabs();

const changeLayout=function ({item},backFun){
  closeAll();
  showRouterFlag.value=false;
  nextTick(()=>{
    frameLayout.value.openPage({item},backFun);
  })
}

watch(() => router.currentRoute.value.path,(toPath) => {
  if(toPath===PageEnum.BASE_HOME_URL){
    showRouterFlag.value=true;
  }
  //如果是打开应用app
  if(toPath===PageEnum.BASE_APP_MAIN_URL){
    showRouterFlag.value=false;
    nextTick(()=>{
      const item= JSON.parse(StorageUtils.getSessionItem("curOpenItem")+"");
      frameLayout.value.openPage({item},()=>{});
    })
  }
  //要执行的方法
},{immediate: true,deep: true})
//刷新界面
usePageFlush(unref(showRouterFlag),changeLayout);
</script>

<style type="text/css" lang="less"></style>
